export default "__VITE_ASSET__jI82dAVT__"